import { render, staticRenderFns } from "./CanvasLegend.vue?vue&type=template&id=5e520966"
import script from "./CanvasLegend.vue?vue&type=script&lang=js"
export * from "./CanvasLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports